export enum STRIPE_CONNECT_ERROR_MESSAGE {
	MISSING_CONNECT_ACCOUNT = 'missing_connect_account',
	HAS_ACTIVE_EVENTS = 'has_active_events',
}

export enum EVENT_ERROR_MESSAGE {
	FAILED = 'reCAPTCHA verification failed. You might be a bot.',
}